import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { normalizeSharedContextCookies } from "@tSurya/Handlers/SharedCookieContext";

const NormalizeSharedContextCookies: typeof RequestDataFromApi = () => {
    normalizeSharedContextCookies();
};

addToChainBefore(chain, RequestDataFromApi, NormalizeSharedContextCookies);